import Minus from "@assets/svg/MyDeliveries/Minus";
import Plus from "@assets/svg/MyDeliveries/Plus";
import _ from "lodash";
import React from "react";
import { TouchableOpacity, View, StyleSheet } from "react-native";
import CustomText from "@components/CustomText";

const AddQuantity = ({ reason, setQuantity, currentQty }) => {
  const handleQuantity = (op) => {
    if (op === "subtract") {
      setQuantity(reason?.key, _.subtract(currentQty, 1));
    } else {
      setQuantity(reason?.key, _.add(currentQty, 1));
    }
  };

  const Update = (
    <View style={styles.updateContainer}>
      <TouchableOpacity
        testID="subtract"
        onPress={() => handleQuantity("subtract")}
      >
        <View style={styles.updateButton}>
          <Minus stroke="rgba(255, 46, 0, 1)" />
        </View>
      </TouchableOpacity>
      <CustomText variant="title_18" style={styles.updateText}>
        {currentQty}
      </CustomText>
      <TouchableOpacity testID="add" onPress={() => handleQuantity()}>
        <View style={styles.updateButton}>
          <Plus
            stroke={true ? "rgba(255, 46, 0, 1)" : "rgba(179, 179, 179, 1)"}
          />
        </View>
      </TouchableOpacity>
    </View>
  );

  const Add = (
    <TouchableOpacity testID="addQuantity" onPress={() => handleQuantity()}>
      <View style={styles.addButtonContainer}>
        <Plus stroke="rgba(255, 46, 0, 1)" />
        <CustomText variant="body_text_4" style={styles.addButtonText}>
          क्वांटिटी
        </CustomText>
      </View>
    </TouchableOpacity>
  );

  return currentQty === 0 ? Add : Update;
};

const styles = StyleSheet.create({
  updateContainer: {
    borderWidth: 1,
    borderColor: "rgba(0, 0, 0, 0.20)",
    flexDirection: "row",
    borderRadius: 8,
    alignItems: "center",
  },
  updateText: {
    color: "rgba(255, 46, 0, 1)",
    paddingHorizontal: 8,
    lineHeight: 22,
  },
  updateButton: {
    paddingHorizontal: 12,
    paddingVertical: 6,
  },
  addButtonContainer: {
    borderRadius: 8,
    borderWidth: 1,
    borderColor: "rgba(0, 0, 0, 0.20)",
    paddingHorizontal: 14,
    paddingVertical: 5,
    flexDirection: "row",
    alignItems: "center",
  },
  addButtonText: {
    color: "rgba(255, 46, 0, 1)",
    marginLeft: 8,
  },
});

export default React.memo(AddQuantity);
